import { Orientation, SidebarState } from "../types/index-type";

const SIDEBAR_STORAGE_KEY = "toggleSlider";
const ORIENTATION_STORAGE_KEY = "orientationAngle";


// Normalise persisted sidebar and orientation state for desktop/tablet flows.
export const checkLocalStorage = (): { sideStatus: SidebarState; angle: Orientation } => {
  const storedSideStatus = localStorage.getItem(SIDEBAR_STORAGE_KEY);
  const storedAngle = localStorage.getItem(ORIENTATION_STORAGE_KEY);

  const sideStatus: SidebarState = storedSideStatus === "close" ? "close" : "open";
  const angle: Orientation = storedAngle === "landscape" ? "landscape" : "portrait";

  localStorage.setItem(SIDEBAR_STORAGE_KEY, sideStatus);
  localStorage.setItem(ORIENTATION_STORAGE_KEY, angle);

  return { sideStatus, angle };
};
